import React from 'react'
import { IconProps } from 'icons/types'
import classnames from 'classnames'
import { ShieldExclamationIcon } from '@heroicons/react/outline'

export const ThreatIcon: React.FC<IconProps> = ({ className }: IconProps) => {
  return <ShieldExclamationIcon className={classnames(className)} />
}
